import { useAtom } from 'jotai'
import { atomWithGlobalStore } from '@highlight/ipc/jotai'
import { ViewFilterMenu, type ViewFilterOption } from '@renderer/overlay/Sidepanel/components/view-filter-menu'
import type { HistoryFilter } from '@renderer/overlay/Sidepanel/hooks/use-history-activity'

/** Persisted so reopening the drawer lands on the list the user last chose. */
export const historyFilterAtom = atomWithGlobalStore<HistoryFilter>('general', 'sidepanel.history.filter', 'all')

const FILTER_OPTIONS: Array<ViewFilterOption<HistoryFilter>> = [
  { value: 'all', label: 'All' },
  { value: 'chat', label: 'Chats' },
  { value: 'audio-note', label: 'Meetings' },
  { value: 'completed-action', label: 'Actions' },
]

interface HistoryFilterMenuProps {
  onFilterChange?: (filter: HistoryFilter) => void
}

/** Type filter in the History view header: "All / Chats / Meetings / Actions". */
export function HistoryFilterMenu({ onFilterChange }: HistoryFilterMenuProps) {
  const [filter, setFilter] = useAtom(historyFilterAtom)

  return (
    <ViewFilterMenu
      value={filter}
      options={FILTER_OPTIONS}
      subject="history"
      onChange={(option) => {
        setFilter(option)
        onFilterChange?.(option)
      }}
    />
  )
}
